module.exports = __webpack_public_path__ + "img/v2.73df847a.jpg";